/**
 * Gewählte Organisation (Mandant, Zielbild zentrale Erfassung, A2).
 *
 * Ein Benutzer kann mehreren Organisationen angehören (Gruppen `kunde:*`).
 * Der Umschalter in der Kopfleiste setzt hier den Slug; der API-Client
 * schickt ihn als `X-Organisation`-Header, das Backend engt alle Listen
 * darauf ein. null = alle Organisationen des Benutzers (Standard).
 */
import { create } from "zustand"

const KEY = "testerwerk:organisation"

interface OrganisationState {
  gewaehlt: string | null
  setGewaehlt: (slug: string | null) => void
}

export const useOrganisationStore = create<OrganisationState>()((set) => ({
  gewaehlt: localStorage.getItem(KEY) || null,
  setGewaehlt: (slug) => {
    if (slug) localStorage.setItem(KEY, slug)
    else localStorage.removeItem(KEY)
    set({ gewaehlt: slug })
  },
}))

/** Für den Request-Interceptor (außerhalb von React) */
export function gewaehlteOrganisation(): string | null {
  return useOrganisationStore.getState().gewaehlt
}
